import st from '../style.module.css';

export const containerClasses = {
  container: st.itemToHover,
};
